import { useMemo } from 'react';

import { useDebounce } from '@/hooks/use-debounce';

import { CASINO_MIN_SEARCH_LENGTH, useCasinoGamesQuery } from './use-casino-games';
import { useRecentlyPlayedGames } from './use-recently-played-games';

const SEARCH_DEBOUNCE_MS = 250;

export const useCasinoDesktopSearch = (query: string) => {
    const trimmedQuery = useDebounce(SEARCH_DEBOUNCE_MS, query.replace(/[,=]/g, ' ').trim());
    const searchQuery = trimmedQuery.length >= CASINO_MIN_SEARCH_LENGTH ? trimmedQuery : '';
    const isSearching = searchQuery.length > 0;

    const { data: recentlyPlayed } = useRecentlyPlayedGames();
    const { data, isPending, isSuccess, hasNextPage, isFetchingNextPage, fetchNextPage } = useCasinoGamesQuery({
        name: searchQuery,
    });

    const results = useMemo(
        () => (isSearching ? data?.pages.flatMap(page => page.items ?? []) ?? [] : []),
        [data, isSearching]
    );
    const recentGames = recentlyPlayed?.items ?? [];
    const showSkeleton = isSearching && isPending;
    const showNoResults = isSearching && isSuccess && results.length === 0;
    const showRecent = recentGames.length > 0 && (!isSearching || showNoResults);

    return {
        searchQuery,
        results,
        recentGames,
        showSkeleton,
        showNoResults,
        showRecent,
        hasNextPage: isSearching && hasNextPage,
        isFetchingNextPage,
        fetchNextPage,
    };
};
